export const navMenu = ["about me","skills"]
const illustration = {
    animated: true // set to false to use static SVG
  };


export const projects = [
  {
      "title" : "Sushi Shop",
      "desc" : "Online store for selling rolls, implemented USING React-Router, SCSS, Mockapi",
      "start" : "to start, write npm install,npm run start",
      "github": "https://github.com/r33n99/sushiMarket",
      "url" : "https://sushimarket.netlify.app/"
  },
{
  "title" : "WhatsApp clone",
  "desc" : "This site CLONES THE original WhatsAppWeb site, implemented USING Styled-Components, React,Context, Firestore and Firebase (Auth)",
  "start" : "to start, write npm install,npm run start",
  "github": "https://github.com/r33n99/whatsApp-clone",
  "url" : "https://whats-app-clone-b75c2.web.app/"
},
{
"title" : "Google search clone",
"desc" : "This site CLONES THE original Google search site, implemented USING Tailwindcss,React,Context,react-router,react-player,react-loader-spinner,use-debounce,craco",
"start" : "to start, write npm install,npm run start",
"github": "https://github.com/r33n99",
"url" : "https://google-clone-reen.netlify.app/"
},
{
"title" : "Weather app",
"desc" : "This site for weather ,implemented USING React, radidapi",
"start" : "to start, write npm install,npm run start",
"github": "https://github.com/r33n99",
"url" : "http://weatherapp-r33n.surge.sh/"
},
{
"title" : "Travel app",
"desc" : "This site for travel,implemented USING React,React-Hooks,axios,material-ui,radidapi",
"start" : "to start, write npm install,npm run start. P.S. have limit 500 requests / month",
"github": "https://github.com/r33n99",
"url" : "https://travel-app-r33n.netlify.app/"
},
{
"title" : "Typescript + React Shop",
"desc" : "This site for shopping,implemented USING React,React-Hooks,material-ui,fakestoreapi,react-query,typescript",
"start" : "to start, write npm install,npm run start",
"github": "https://github.com/r33n99",
"url" : "https://typescript-react-shop.surge.sh/"
},
{
  "title" : "Online book store",
  "desc" : "An application for viewing information about the book, it is also possible to add to favorites for further actions, technologies: React,Redux(redux-toolkit),react-router,axios,mockAPI,react-hook-form",
  "url" : "https://online-library.surge.sh/"
},
{
  "title" : "covid-19 whistleblower",
  "desc" : "Application for viewing information about coronavirus in the desired area, and the total indicators for the last 5 days, also the highest rate of infections among this period of time, technologies: React,axios,scss,redux(redux-toolkit)",
  "url" : "https://covid19-app-r33n.surge.sh/"
},
{
  "title" : "Application for issuing parking tickets",
  "desc" : "This application can be used to issue parking tickets, technologies: Nuxt(vue,vuex),axios,Vuetify,adonis.js",
  "url" : "https://tickets-r33n.surge.sh/"
}
]


  const techStack = {
    viewSkillBars: true, //Set it to true to show Proficiency Section
    experience: [
      {
        Stack: "HTML 5", //Insert stack or technology you have experience in
        progressPercentage: "75%" //Insert relative proficiency in percentage
      },
      {
        Stack: "CSS,SCSS",
        progressPercentage: "80%"
      },
      {
        Stack: "JavaScript",
        progressPercentage: "80%"
      },
      {
        Stack: "Typescript",
        progressPercentage: "70%"
      },
      {
        Stack: "React",
        progressPercentage: "80%"
      },
      {
        Stack: "redux",
        progressPercentage: "80%"
      },
      {
        Stack: "Next",
        progressPercentage: "60%"
      },
      {
        Stack: "Vue",
        progressPercentage: "60%"
      },
      {
        Stack: "Vuex",
        progressPercentage: "60%"
      },
      {
        Stack: "Nuxt",
        progressPercentage: "70%"
      },
      {
        Stack: "Adonis.js",
        progressPercentage: "60%"
      },
      {
        Stack: "Git",
        progressPercentage: "70%"
      },

    ],
    displayCodersrank: true
  };
  
  
  export {
    illustration,
    techStack,
  };
